import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HistorySection from "@/components/HistorySection";
import CommunityBoard from "@/components/CommunityBoard";
import ShareButton from "@/components/ShareButton";
import BackToTopButton from "@/components/BackToTopButton";
import { useAlertCount } from "@/components/AlertsPanel";
import { useSEO } from "@/hooks/useSEO";
import { scrollToPageTop } from "@/lib/scroll";

export default function History() {
  const alertCount = useAlertCount();
  // Lazy-loaded routes can finish loading *after* the router fires its
  // scroll-to-top — force one more reset on actual mount.
  React.useEffect(() => { scrollToPageTop(); }, []);
  useSEO({
    title: "History of Popoyo, Nicaragua — Archive & Photos · Popoyo.app",
    description:
      "The complete history of Popoyo & Tola, Nicaragua — from artisanal fishing village to the birth of surf tourism (Popoyo Surf Lodge, 1999) and today's Emerald Coast. The 1992 tsunami, land reform, Playa Colorado & Hacienda Iguana, El Astillero, and historic archive photos.",
    path: "/history",
  });
  return (
    <div className="min-h-screen flex flex-col bg-[color:var(--sand)]">
      <Header alertCount={alertCount} />
      <main className="flex-1 max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center justify-end mb-4">
          <ShareButton
            path="/history"
            title="History of Popoyo — Popoyo.app"
            text="Discover how a quiet Pacific fishing village became Nicaragua's surf capital."
            testId="share-history-btn"
          />
        </div>
        <HistorySection />
        <CommunityBoard />
      </main>
      <BackToTopButton />
      <Footer />
    </div>
  );
}
